import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../../Helper/Context"
import { Loading } from "../../../../../Helper/Loading"
import { useTranslation } from "react-i18next"
import EducationGardenDailyCheklistModal from "../../EducationDashboard/EducationGardenDailyChecklist/Modal/EducationGardenDailyCheklistModal"
import EducationEmpContratorWorkModal from "../../EducationDashboard/EducationWorkAssignOfficialsContractorPending/Modal/EducationEmpContratorWorkModal"
export const HealthDailyChecklist = (props) => {
    const {
        YearValue,
        MonthValue,
        WardValue,
        ZoneValue,
        AssetType,
        Date,
        Language,
        WorkActiveButton,
        ActiveButton,
    } = props


    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    // console.log("WorkActiveButton",WorkActiveButton)

    const [OpenModal, setOpenModal] = useState(false)
    const [Flag, setFlag] = useState('')

    const [tableData, settableData] = useState([])
    const [apiFlag, setapiFlag] = useState('')
    const [Data, setData] = useState('')
    const [loader, setloader] = useState(false)

    const [EmployeeAndContractorWorkPopupShow, setEmployeeAndContractorWorkPopupShow] = useState({
        show: false,
        data: '',
        ShowBy: ''
    })

    const handleEmployeeAndContractorWorkPopup = (data, ShowBy) => {
        setEmployeeAndContractorWorkPopupShow({
            show: true,
            data: data,
            ShowBy: ShowBy
            // flag: flag
        })
    }


    const handleOnCloseClick = () => {
        setEmployeeAndContractorWorkPopupShow({
            show: false,
            data: '',
            // flag: flag
        })
    }

    const handleOpenModal = (flag, data, APIFlag) => {
        if (flag == 'Visit Target') {
            if ((data?.m_UserID != 4 && data?.m_UserID != 2364 && data?.m_UserID != 2363 && data?.m_UserID != 30 && data?.m_UserID != 32)) {
                setOpenModal(!OpenModal)
            }
        }
        if (flag == 'Achievement') {
            setOpenModal(!OpenModal)
        }
        if (flag == 'Pending') {
            console.log('')
        }

        setFlag(flag)
        setData(data)
        setapiFlag(APIFlag)
    }

    useEffect(() => {
        setloader(true)
        const data = {
            M_FinancialYearID: YearValue,
            M_MonthID: MonthValue,
            M_ZoneID: 0,
            Date: Date,
            M_AssetTypeID: AssetType,
            M_WorkTypeID: WorkActiveButton,
            M_WardID: WardValue,
            M_UsersID: UserID,
            token: token,
            From: 1,
            To: 99999,
            Flag: 'Garden',
            handleGetData: handleGardenData,
            Language: Language.Label,
            setloader: setloader
        }
        // {
        //     ((YearValue != 0 && MonthValue != 0) && (Language.Label != undefined && Date != undefined) && Language.Label != '') &&
        //         dispatch(GetChecklistProgressSelectDataAPI({ data }))
        // }
    }, [YearValue, MonthValue, ZoneValue, WardValue, Date, Language.Label, WorkActiveButton])

    const handleGardenData = (result) => {
        settableData(result)
    }

    const { isLoading } = useSelector(state => state.GetChecklistProgressSelectData)

    const TableData = {
        "code": 200,
        "status": true,
        "message": "Successful",
        "mainHeading": [
            {
                "manihead": "ठेकेदार तपशील",
                "no": 3
            },
            {
                "manihead": "आठवडा पहिला",
                "no": 3
            },
            {
                "manihead": "आठवडा दुसरा",
                "no": 3
            },
            {
                "manihead": "आठवडा तिसरा",
                "no": 3
            },
            {
                "manihead": "आठवडा चौथा",
                "no": 3
            },
            {
                "manihead": "एकूण",
                "no": 4
            }
        ],
        "heading": [
            {
                "head": "झोन"
            },
            {
                "head": "ठेकेदाराचे नाव"
            },
            {
                "head": "चेकलिस्टचे नाव"
            },
            {
                "head": "टार्गेट"
            },
            {
                "head": "पूर्ण"
            },
            {
                "head": "प्रलंबित"
            },
            {
                "head": "टार्गेट"
            },
            {
                "head": "पूर्ण"
            },
            {
                "head": "प्रलंबित"
            },
            {
                "head": "टार्गेट"
            },
            {
                "head": "पूर्ण"
            },
            {
                "head": "प्रलंबित"
            },
            {
                "head": "टार्गेट"
            },
            {
                "head": "पूर्ण"
            },
            {
                "head": "प्रलंबित"
            },
            {
                "head": "टार्गेट"
            },
            {
                "head": "पूर्ण"
            },
            {
                "head": "प्रलंबित"
            },
            {
                "head": "वाटप कामे"
            }
        ],
        "data": [
            {
                "m_EmployeeID": 2,
                "employeeName": "कल्याण स्वंय संस्था",
                "m_UserID": 4,
                "m_ZoneID": 0,
                "zoneName": "खोलीतील फरशी साफसफाई व कट्टा मारणे",
                "designationName": "अ",
                "week1_VisitTarget": 2,
                "week1_Achievement": 1,
                "week1_Pending": 1,
                "week2_VisitTarget": 2,
                "week2_Achievement": 1,
                "week2_Pending": 1,
                "week3_VisitTarget": 2,
                "week3_Achievement": 1,
                "week3_Pending": 1,
                "week4_VisitTarget": 2,
                "week4_Achievement": 1,
                "week4_Pending": 1,
                "total_VisitTarget": 2,
                "total_Achievement": 1,
                "total_Pending": 1,
                "kpI_Assign": 1
              },
        ]
    }

    return (
        <>
            <div className="row ps-3 pb-3 pe-0">
                {/* {loader && <Loading />} */}
                {/* style={{ width: '90vw', overflow: 'scroll' }} */}
                <div className="col-12 mb-3 ps-0 pe-0">
                    <div style={{ height: '65vh' }} className='row mob_table table-responsive py-2 ps-2 pe-3 '>

                        <table id="totalordergenerated" cellPadding="0" cellSpacing="0" border="0" className="table table-bordered">
                            <thead className="gardenworktable" id="customers" style={{ position: 'sticky', top: -10 }}>

                                <tr className="text-center tablethhead">
                                    {
                                        TableData && TableData.mainHeading && TableData.mainHeading.length > 0 && TableData.mainHeading.map((i, index) => {
                                            return (
                                                <th key={index} colSpan={i.no} className="text-center fw-bold fs-6" id="tablecolor">
                                                    {i.manihead}
                                                </th>
                                            );
                                        })
                                    }
                                </tr>


                                <tr className="text-center gardenworkth" style={{ width: '100%' }}>
                                    {
                                        TableData && TableData.heading && TableData.heading.length > 0 && TableData.heading.map((j, index) => {
                                            return (
                                                <th key={index} className={Language?.Label === 'English' ? "text-center fw-bold widthmanage" : "text-center fw-bold"} style={{ whiteSpace: 'nowrap' }}>
                                                    {j.head}
                                                </th>
                                            );
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    TableData && TableData.data && TableData.data.length > 0 ?

                                        TableData.data.map((officer) => (
                                            <tr>
                                               <td className="verticalAllign">{officer?.designationName}</td>
                                                <td className="verticalAllign">{officer?.employeeName}</td>
                                                <td className="text-center verticalAllign">{officer?.zoneName}</td>
                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week1_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week1')}>{officer?.week1_VisitTarget}</td>
                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week1_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week1')} >{officer?.week1_Achievement}</td>
                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week1_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week1')}>{officer?.week1_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week2_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week2')}>{officer?.week2_VisitTarget}</td>
                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week2_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week2')}>{officer?.week2_Achievement}</td>
                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week2_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week2')}>{officer?.week2_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week3_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week3')}>{officer?.week3_VisitTarget}</td>
                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week3_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week3')}>{officer?.week3_Achievement}</td>
                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week3_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week3')}>{officer?.week3_Pending}</td>

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week4_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week4')}>{officer?.week4_VisitTarget}</td>
                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week4_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week4')}>{officer?.week4_Achievement}</td>
                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week4_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week4')}>{officer?.week4_Pending}</td>

                                                {
                                                    (officer?.week5_VisitTarget && officer?.week5_VisitTarget != undefined) &&
                                                    <>
                                                        <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.week5_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Week5')}>{officer?.week5_VisitTarget}</td>
                                                        <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.week5_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Week5')}>{officer?.week5_Achievement}</td>
                                                        <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.week5_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Week5')}>{officer?.week5_Pending}</td>
                                                    </>
                                                }

                                                <td className="text-center verticalAllign cursor-pointer bluecolorCount" onClick={(e) => (officer?.total_VisitTarget == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Visit Target', officer, 'VisitTarget_Total')}>{officer?.total_VisitTarget}</td>
                                                <td className="text-center verticalAllign cursor-pointer greencolorCount" onClick={(e) => officer?.total_Achievement == 0 ? e.preventDefault() : handleOpenModal('Achievement', officer, 'Achievement_Total')}>{officer?.total_Achievement}</td>
                                                <td className="text-center verticalAllign cursor-pointer orangecolorCount" onClick={(e) => (officer?.total_Pending == 0 || WorkActiveButton != 1) ? e.preventDefault() : handleOpenModal('Pending', officer, 'Pending_Total')}>{officer?.total_Pending}</td>

                                                <td className="text-center verticalAllign fw-bold">
                                                    <span className='cursor-pointer fw-bold'
                                                        onClick={() => handleEmployeeAndContractorWorkPopup(officer, 'All')}>
                                                        {officer?.kpI_Assign}
                                                    </span>
                                                </td>
                                            </tr>
                                        )) :

                                        <tr>
                                            <td colSpan={TableData.mainHeading.reduce((sum, item) => sum + item.no, 0)} className="text-center">
                                                No data available...
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
            {
                OpenModal &&
                <EducationGardenDailyCheklistModal
                    handleOpenModal={handleOpenModal}
                    Title={Flag == 'Visit Target' ? t('EmployeeAndContractor.VisitTarget') : Flag == 'Achievement' ? t('EmployeeAndContractor.Achievement') : t('EmployeeAndContractor.Pending')}
                    Flag={Flag}
                    YearValue={YearValue}
                    MonthValue={MonthValue}
                    WardValue={WardValue}
                    ZoneValue={ZoneValue}
                    Language={Language}
                    AssetType={AssetType}
                    Data={Data}
                    apiFlag={apiFlag}
                    setOpenModal={setOpenModal}
                    WorkActiveButton={WorkActiveButton}
                />
            }

            {
                EmployeeAndContractorWorkPopupShow.show ?
                    <EducationEmpContratorWorkModal
                        open={EmployeeAndContractorWorkPopupShow.show}
                        cancelbtn={handleOnCloseClick}
                        ActiveButton={ActiveButton}
                        GridData={EmployeeAndContractorWorkPopupShow.data}
                        PopUpApiFlag={EmployeeAndContractorWorkPopupShow.flag}
                        ShowBy={EmployeeAndContractorWorkPopupShow.ShowBy}
                        FromDate=''
                        ToDate=''
                        WorkType='0'
                        ZoneNameDDLID='0'
                        WardName='0'
                        flag="Daily Work"
                        YearValue={YearValue}
                        MonthValue={MonthValue}
                        WorkActiveButton={WorkActiveButton}
                        AssetType={AssetType}
                    />
                    : <></>
            }
        </>
    )
}